import type { DailyOverviewData } from "@/api/Capacity";
import { isVisitCategory } from "@medoma/models/activities";
import {
  medicalCompetenceSchema,
  type IMedicalCompetence,
} from "@medoma/models/shifts";
import { sumCounts } from "@/Utils/numberUtils";
import { calculateIncludedShiftsCount } from "../capacityOverviewUtils";

// Only nurses and nurse assistants — the purpose of the daily overviews panel is to get a quick
// overview of the most important information that best reflects capacity for each day.
export const dailyOverviewsCompetences: IMedicalCompetence[] = [
  medicalCompetenceSchema.enum.NursePractitioner,
  medicalCompetenceSchema.enum.NurseAssistant,
];

export const calculateVisitsPerShift = (
  competenceCapacity: DailyOverviewData["competenceCapacity"],
): number | null => {
  const includedShiftsCount = calculateIncludedShiftsCount(
    competenceCapacity.flatMap(({ shiftsByType }) => shiftsByType),
  );

  if (includedShiftsCount === 0) {
    return null;
  }

  const totalVisits = sumCounts(
    competenceCapacity.flatMap(({ categoryCounts }) =>
      categoryCounts.filter(({ category }) => isVisitCategory(category)),
    ),
  );

  return totalVisits / includedShiftsCount;
};
